import axios from "axios";
import { getAccessToken, setAccessToken } from "../services/authService";
import { clearSession } from "../services/authHelper";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/api/v1",
  withCredentials: true,
});

// ✅ Función que actualiza la configuración con un nuevo token
const retryWithNewToken = async (error) => {
  try {
    console.log("🔄 Access token expirado, intentando refrescar...");

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/auth/refresh-token`,
      {},
      { withCredentials: true }
    );
    setAccessToken(data.accessToken);  // ✅ Guarda el nuevo token
    error.config.headers.Authorization = `Bearer ${data.accessToken}`;
    
    return apiClient(error.config);  // ✅ Reintentar la solicitud original
  } catch (refreshError) {
    clearSession();  // ✅ Cierra sesión si el refresh token es inválido
    return Promise.reject(refreshError);
  }
};

// ✅ Interceptor de peticiones: agrega el token si existe
apiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Interceptor de respuestas: intenta refrescar el token si es 401
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      return retryWithNewToken(error);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
